<template>
  <router-view />
</template>

<script>
export default {
  name: 'MobileOrderStatusIndex',
};
</script>
